<template>
  <v-menu top offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-if="ranchName !== null" v-on="on" text class='blue--text pa-0 body-2 ml-n1 text-sm-left' min-width="50">
        <span style="text-decoration: underline;">{{ vid }}</span>
      </v-btn>
      <h4 v-else class="body-2 text-no-wrap">{{ vid }}</h4>
    </template>
    <v-list dense>
      <v-list-item>
        <v-list-item-content class="pr-0">
          <v-list-item-title>{{ ranchName }}</v-list-item-title>
          <v-list-item-subtitle>{{ contactName }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'BeefboosterRanchMenu',
  props: {
    vid: {
      type: String,
      default: null
    },
    ranch: {
      type: Object,
      default: null
    }
  },
  computed: {
    ranchName () {
      return this.ranch !== null
        ? this.ranch.ranchName
        : null
    },
    contactName () {
      return this.ranch !== null
        ? this.ranch.contactName
        : null
    }
  }
}
</script>
